import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { getErrorHandlingOptions } from '../base/headers';
import { ZollerMode } from '../../models/zoller-mode';
import { ZollerModeBuilder } from '../../models/builders/zoller-mode.builder';

const zollerModeBody = (zollerMode: ZollerMode) => ({
  name: zollerMode.name
});

@Injectable()
export class ZollerModeApiService {
  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${ environment.apiUrl }zollerModes`;
  }

  getZollerModes() {
    return this.httpClient.get(`${ this.apiUrl }`, getErrorHandlingOptions())
      .pipe(
        map(ZollerModeBuilder.fromList)
      );
  }

  getZollerMode(hash: string) {
    return this.httpClient.get(`${ this.apiUrl }/${ hash }`)
      .pipe(
        map(ZollerModeBuilder.fromJson)
      );
  }

  createZollerMode(zollerMode) {
    return this.httpClient.post(this.apiUrl, zollerModeBody(zollerMode)).pipe(map(ZollerModeBuilder.fromJson));
  }

  updateZollerMode(zollerMode: ZollerMode) {
    return this.httpClient.put(`${ this.apiUrl }/${ zollerMode.hash }`, zollerModeBody(zollerMode));
  }

  deleteZollerMode(zollerMode: ZollerMode) {
    return this.httpClient.delete(`${ this.apiUrl }/${ zollerMode.hash }`);
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/zoller-mode-api.service.ts